<template>
  <v-container>
    <v-layout>
      <v-flex>
        <h3>Translate: Irish to English</h3>
        <h2 v-show="prompt">
          Question: {{ prompt ? prompt.answers.join(", ") : "" }}
          <v-btn
            style="float: right"
            round
            small
            fab
            color="primary"
            @click="showHint = !showHint"
          >
            ?
          </v-btn>
        </h2>
      </v-flex>
    </v-layout>
    <v-layout column justify-space-around align-space-around>
      <!-- <h3>{{this.selectedVerbCategory}}</h3> -->
      <v-card
        id="hint"
        v-show="showHint"
        color="primary"
        elevation="2"
        outlined
        style="max-width: 50%"
      >
        <div class="hintText">
          <p style="margin-bottom: 0 !important">
            <b>Verb: </b>{{ prompt.verb }}
          </p>
          <p style="margin-bottom: 0 !important">
            <b>Tense: </b> {{ prompt.tense }}
          </p>
          <p style="margin-bottom: 0 !important">
            <b>Form: </b> {{ prompt.depForm }}
          </p>
        </div>
      </v-card>
      <v-flex ma-2>
        <!-- <v-select :items="tenses" label="Tense/Mood" v-model="selectedTense"></v-select> -->
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <div v-for="j in 6" v-bind:key="j">
          <v-card
            @click="markChoice(j)"
            rounded-lg
            block
            :color="buttonColor(j)"
            ripple
            class="mt-3 pa-2"
          >
            <v-flex align-self-center class="title">
              <v-layout justify-center pt-1 pb-1>
                {{ enumerated[j - 1] }}
              </v-layout>
            </v-flex>
          </v-card>
        </div>

        <div v-if="prompt">
          <!-- <v-text-field label="Answer" v-model="verbAnswer"></v-text-field> -->
          <!-- <v-btn v-show="!answered" @click="onSubmit">Check</v-btn> -->
          <h3 v-show="answered">{{ correct ? "Correct" : "Incorrect" }}</h3>
          <h3 v-show="answered">Answers</h3>
          <div v-show="answered">{{ translateAnswer(prompt) }}</div>
        </div>
        <span class="btn-bottom">
          <v-btn
            round
            outline
            flat
            color="primary"
            @click="checkWordButton(selectedChoice)"
            v-if="!answered && selectedChoice > 0"
            >Check</v-btn
          >
          <v-btn
            round
            outline
            color="primary"
            @click="handleSkip"
            v-if="!answered"
            >Skip</v-btn
          >
          <v-btn round outline color="primary" @click="onSubmit" v-else
            >Next</v-btn
          >
        </span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { SAMPLE_VERBS } from "@/constants.js";
import {
  conjugate,
  generateStem,
  enumerateConjugations,
  allFormsOfWord,
  removeAsterisk,
} from "@/conjugation.js";
import { randomConjugationPrompt } from "@/verbprompts.js";
import { translateTable, translateConjugationPrompt } from "@/linguaEng.js";
export default {
  name: "ConjugationToTranslation",
  props: {
    prompt: {
      type: Object,
      default: function () {
        return randomConjugationPrompt(_.sample(SAMPLE_VERBS));
      },
    },
    controlled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      verbStem: "",
      sampleVerbs: SAMPLE_VERBS,
      depForms: ["Dependent", "Independent"],
      depFormRadio: "None",
      // prompt: null,
      verbAnswer: null,
      answered: false,
      correctAnswer: "",
      correct: null,
      buttonColors: [],
      showHint: false,
      selectedChoice: -1,
      correctChoice: -1,
    };
  },
  mounted() {
    let JsLingua = require("jslingua");
  },
  methods: {
    onSubmit() {
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    handleAnswer() {
      this.correctAnswer = translateConjugationPrompt(this.prompt);
      this.correct = this.correctAnswer.indexOf(this.verbAnswer) >= 0;
      this.$emit("check", { correct: this.correct });
      this.answered = true;
    },
    clear() {
      this.buttonColors = [];
      this.selectedChoice = this.correctChoice = -1;
      if (this.controlled) {
        this.$emit("next");
      } else {
        this.prompt = randomConjugationPrompt(_.sample(SAMPLE_VERBS));
      }
      this.answered = false;
      this.verbAnswer = "";
    },
    handleSkip: function () {
      this.clear();
    },
    expandWord: function (word) {
      var wordString = allFormsOfWord(word).join(", ");
      return wordString;
    },
    checkWordButton(index) {
      if (!this.answered) {
        var word = this.enumerated[index - 1]
        this.correctAnswer = translateConjugationPrompt(this.prompt);
        this.correct = this.correctAnswer == word;
        this.$emit("check", { correct: this.correct });
        this.answered = true;
      }
    },
    translateAnswer(answer) {
      return translateConjugationPrompt(answer);
    },
    stripAsterisk(word) {
      return removeAsterisk(word);
    },
    markChoice(index) {
      if (!this.answered) this.selectedChoice = index;
    },
    buttonColor(btnIndex) {
      if (this.answered && this.correct && this.selectedChoice === btnIndex)
        return "green";
      else if (this.selectedChoice === btnIndex)
        return this.answered ? "red darken-3" : "cyan lighten-3";
      else return "grey lighten-3";
    },
  },
  computed: {
    selectedVerbCategory() {
      var cat = this.sampleVerbs.find((x) => x.verb === this.dictionaryForm);
      if (cat) return this.categories[cat.cat - 1];
      else return this.categories[0];
    },
    conjugated() {
      if (this.stem.length > 0) {
        return conjugate(
          this.selectedPerson,
          this.selectedNumber,
          this.selectedVerbCategory,
          this.selectedTense,
          this.depFormRadio,
          this.stem
        );
      }
    },
    stem() {
      return generateStem(
        this.prompt.verb,
        this.prompt.category,
        this.prompt.tense
      );
    },
    enumerated() {
      this.dictionaryForm = this.prompt.verb;
      if (this.stem.length > 0) {
        this.depFormRadio = this.prompt.depForm;
        this.selectedTense = this.prompt.tense;
        return translateTable(this.prompt);
      }
    },
  },
};
</script>

<style scoped>
incorrect {
  color: red;
}
th,
td {
  outline: none;
  padding: 1em;
}
* {
  text-transform: none !important;
}
button {
  white-space: normal;
  width: 200px;
  font-weight: bold;
  padding: 10px 5px;
}

button:hover {
  background-color: aliceblue;
}

#wordButton {
  padding: 20px;
}

.hintText {
  color: white;
  padding: 20px;
  margin-bottom: 0px !important;
}

.btn-bottom {
  position: absolute;
  bottom: 0;
  padding: 16px 0px;
}
</style>